import React, { useState } from 'react';
import './Portfolio.css'; // Import your CSS file

function Portfolio({ data }) {
  // Create an array to track active sections for each card
  const [activeSections, setActiveSections] = useState(data.map(() => '#about'));

  // Function to handle button click for a specific card
  const handleButtonClick = (index, targetSection) => {
    // Create a copy of the activeSections array and update the specific index
    const updatedActiveSections = [...activeSections];
    updatedActiveSections[index] = targetSection;
    setActiveSections(updatedActiveSections);
  };

  return (
    <div style={{margin:'auto'}} align='center' className="container5">
      {data.map((card, index) => (
        <div style={{margin:'auto'}} align='center'  className={`card`} data-state={activeSections[index]} key={card.id}>
          <div className="card-header">
            <div
              style={{
                backgroundImage: `url('${card.imageUrl}')`,
              }}
              className="card-cover"
            ></div>
            <h1 className="card-fullname">{card.name}</h1>
            <h2 className="card-jobtitle">{card.jobTitle}</h2>
          </div>
          <div className="card-main">
            <div
              className={`card-section ${activeSections[index] === '#about' ? 'is-active' : ''}`}
              id="about"
            >
              <div className="card-content">
                <div className="card-subtitle">Description</div>
                <div className="card-desc-container">
                  <p className="card-desc">
                    {card.about}
                  </p>
                </div>
              </div>
            </div>
            <div
              className={`card-section ${activeSections[index] === '#experience' ? 'is-active' : ''}`}
              id="experience"
            >
              <div className="card-content">
                <div className="card-subtitle">Tech Stack</div>
                <div className="card-tech-stack">
                  {card.techStackData.map((tech, techIndex) => (
                    <div
                      key={techIndex}
                      className={`card-tech-item ${activeSections[index] === '#experience' ? 'is-active' : ''}`}
                      onClick={() => handleButtonClick(index, '#experience')}
                    >
                      {tech}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`card-section ${activeSections[index] === '#contact' ? 'is-active' : ''}`}
              id="contact"
            >
              <div className="card-content">
                <div className="card-subtitle">CONTACT</div>
                <div className="card-contact-wrapper">
                  <div className="card-contact">
                    {card.liveLink && (
                      <a
                        href={card.liveLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="live-button"
                      >
                        Live
                      </a>
                    )}
                    {card.liveLink && card.githubLink && <span className="button-separator"></span>}
                    {card.githubLink && (
                      <a
                        href={card.githubLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="github-button"
                      >
                        Github
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-buttons">
              <button
                onClick={() => handleButtonClick(index, '#about')}
                className={activeSections[index] === '#about' ? 'is-active' : ''}
                data-section="#about"
              >
                ABOUT
              </button>
              <button
                onClick={() => handleButtonClick(index, '#experience')}
                className={activeSections[index] === '#experience' ? 'is-active' : ''}
                data-section="#experience"
              >
                Tech Stack
              </button>
              <button
                onClick={() => handleButtonClick(index, '#contact')}
                className={activeSections[index] === '#contact' ? 'is-active' : ''}
                data-section="#contact"
              >
                Link
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Portfolio;
